
import React from 'react';
import { Badge } from '@/components/ui/badge';
import type { UserRole as UserRoleType } from '@/types/feedback';

type UserRoleProps = {
  role: string;
};

const UserRole: React.FC<UserRoleProps> = ({ role }) => {
  // Normalize the role to ensure consistency
  let normalizedRole: UserRoleType = 'individual';
  
  if (role === 'admin') {
    normalizedRole = 'admin';
  } else if (role === 'corporate' || role === 'entreprise' || role === 'recruteur') {
    normalizedRole = 'corporate';
  } else if (role === 'individual' || role === 'candidat') {
    normalizedRole = 'individual';
  }
  
  // Map normalized roles to their display styles
  switch(normalizedRole) {
    case 'admin':
      return <Badge className="bg-red-500">Admin</Badge>;
    case 'corporate':
      return <Badge className="bg-blue-500">Corporate</Badge>;
    case 'individual':
      return <Badge className="bg-green-500">Individual</Badge>;
    default:
      // For any non-standard roles, use the original role string
      return <Badge variant="outline">{role}</Badge>;
  }
};

export default UserRole;
